import { OptimizelyProvider } from '@optimizely/react-sdk';
import { PropsWithChildren } from 'react';

import { optimizely } from '@/lib/optimizely';
import { useAppSelector } from '@/redux/hooks';
import { getFeatureFlagUserLoaded, getOptimizelyUser } from '@/redux/slices/featureFlagSlice';

type FeatureFlagProviderProps = PropsWithChildren;

export const FeatureFlagProvider = ({ children }: FeatureFlagProviderProps) => {
  const userAttributes = useAppSelector(getOptimizelyUser);
  const userLoaded = useAppSelector(getFeatureFlagUserLoaded);

  if (!userLoaded) return null;

  return (
    <OptimizelyProvider optimizely={optimizely} user={userAttributes}>
      {children}
    </OptimizelyProvider>
  );
};
